import { Controller, useForm } from "react-hook-form";
import { useConsentUser, useUserConsent } from "~/data/useConsentUser";

const TermsAndCondition = () => {
  return (
    <div className="flex w-full flex-col gap-4 text-justify text-base text-light-150">
      <h1 className="text-left text-7xl font-bold italic">RFOX VALT</h1>
      <h2 className="text-left text-4xl font-bold italic text-primary-100">
        Metaverse Terms and Conditions
      </h2>
      <h3 className="text-left text-3xl font-bold italic">Background</h3>
      <p>
        RFOX VALT (“VALT”) is a fully immersive, virtual reality-driven retail
        and entertainment experience in the metaverse that combines gaming
        elements, and brings together the best-in-class of cryptocurrencies
        through NFTs and real-world applications of e-commerce, gaming,
        entertainment, and more.
      </p>
      <p>
        These Terms and Conditions constitute a legally binding agreement made
        between you, whether personally or on behalf of an entity (“you”) and
        VALT (“we”, “us”, or “our”) concerning your access to and use of the
        VALT website and services (
        <a
          className="font-bold text-primary-100 underline"
          href="https://www.rfoxvalt.com/"
        >
          https://www.rfoxvalt.com/
        </a>
        ) , as well as any other media form, media channel, mobile website, or
        mobile application related, linked, or otherwise connected thereto
        (collectively, the “VALT”).
      </p>
      <p>
        The information on the VALT or our website is not intended for
        distribution purposes or to be used by any person or entity in any
        jurisdiction or country where such distribution or use would be contrary
        to law or regulation or which would subject us to any registration
        requirement within such jurisdiction or country. Accordingly, persons
        who choose to access the VALT from other locations do so on their own
        initiative and are solely responsible for compliance with local laws, to
        the extent local laws are applicable.
      </p>
      <p>
        Information on this website is not, in any circumstance, financial
        advice. The Company nor any of its affiliates will or shall provide
        financial advice in any form. Any purchase or sale you make, accept, or
        facilitate outside of the VALT will be entirely at your own risk. You
        expressly indemnify us and hold us harmless for any losses you may incur
        by transacting or facilitating transactions outside of this VALT.
      </p>
      <p>
        This document contains very important information regarding your rights
        and obligations, as well as conditions, limitations, and exclusions that
        may apply to you. Please read it carefully.
      </p>
      <ol type="1" role="list" className="list-inside list-decimal">
        <li>
          <b>ACCEPTANCE OF THESE TERMS AND CONDITIONS</b>
          <div className="m-4 flex flex-col gap-4">
            <p>
              Our services are only available to you upon acceptance of these
              terms and conditions. By using the services, you agree that you
              have read, understood, and agree to be bound by all of these terms
              and conditions. If you do not agree and/or accept all of these
              terms and conditions of use, then you are expressly prohibited
              from using our services and you must discontinue use immediately.
            </p>
            <p>
              By using the VALT or any part of it, or by clicking &rsquo;I
              accept&lsquo; below or indicating your acceptance in an adjoining
              box, you are confirming that you understand and agree to be bound
              by all of these terms.
            </p>
            <p>
              Upon acceptance of these terms, you also consent to receive
              marketing emails from us. If at any point you wish to opt out of
              these emails, you may do so by visiting your profile on our
              website at{" "}
              <a
                href="https://portal.rfoxvalt.com/profile"
                className="font-bold text-primary-100 underline"
              >
                https://portal.rfoxvalt.com/profile
              </a>
              . We respect your right to privacy and will promptly act on any
              decision to discontinue receiving marketing communication.
            </p>
            <p>
              Furthermore, you understand and acknowledge that deleting your
              account from our platform at{" "}
              <a
                href="https://portal.rfoxvalt.com/profile"
                className="font-bold text-primary-100 underline"
              >
                https://portal.rfoxvalt.com/profile
              </a>
              will result in permanent removal of your account. Following the
              account deletion your personal data will be retained for a period
              of 30 days. This data retention is solely for regulatory
              compliance and does not imply an option for account recovery.
              After this 30-day period, all of your personal data will be
              permanently deleted from our systems and will no longer be
              retrievable.
            </p>
          </div>
        </li>
        <li>
          <b>CHANGES TO THESE TERMS AND CONDITIONS</b>

          <div className="m-4 flex flex-col gap-4">
            Supplemental terms and conditions or documents that may be posted on
            the VALT from time to time are hereby expressly incorporated herein
            by reference. We reserve the right, in our sole discretion, to make
            changes or modifications to these Terms and Conditions at any time
            and for any reason. We will alert you of any changes by updating the
            “Last Updated” date of these Terms and Conditions, and you waive any
            right to receive specific notice of each such change. It is your
            responsibility to periodically review these Terms and Conditions to
            stay informed of updates. You will be subject to and will be deemed
            to have been made aware of and to have accepted, the changes in any
            revised Terms of Use by your continued use of the VALT after the
            date such revised Terms and Conditions are posted.
          </div>
        </li>
        <li>
          <b>APPLICATION OF THESE TERMS AND CONDITIONS</b>
          <div className="m-4 flex flex-col gap-4">
            <p>
              These Terms and Conditions apply to all users of all VALT
              services, including individuals, merchants, and legal entities.
            </p>
            <p>
              VALT users are those who use and/or purchase VALT or affiliated
              services. You are also responsible for the activities of all users
              of the Service to who you may grant access.
            </p>
            <p>
              The VALT is intended for users who are at least 16 years old.
              People under the age of 16 are not permitted to use or register to
              purchase VALT on the VALT.
            </p>
          </div>
        </li>
        <li>
          <b>YOUR RESPONSIBILITIES</b>
          <div className="m-4 flex flex-col gap-4">
            <p>
              You will not attempt to derive any code or extract the software
              from, or, except to the extent expressly permitted by us, prepare
              derivative works based on the VALT, or otherwise exploit the VALT
              or any software, content, or services made available through the
              VALT, or any applicable third party.
            </p>

            <p>
              When using the VALT, you are also responsible for following all
              applicable laws, including providing any notice or getting any
              consent from other individuals who use or interact with your
              account on the VALT, to the degree needed by privacy or data
              protection laws.
            </p>

            <p>
              Additionally, you acknowledge that because of the use of virtual
              reality in VALT&lsquo;s Services, the Services you access can be
              physically challenging. In using our Services, you are responsible
              for your own health and safety. To reduce the risk of potential
              injury to yourself or others, and damage to your surroundings,
              please ensure you have read and understood the relevant safety
              warnings on the devices you are using. If in doubt, please consult
              a physician or professional before using our Services.
            </p>

            <p>
              In the event, we believe you have breached your responsibilities
              we may terminate access to our services at our sole discretion.
            </p>
          </div>
        </li>
        <li>
          <b>YOUR PERMISSIONS</b>
          <div className="m-4 flex flex-col gap-4">
            By accessing and/or using the Services, you give us permission to:
            <ol
              role="list"
              type="a"
              className="ml-8 flex list-outside list-[lower-alpha] flex-col gap-4"
            >
              <li>
                Use the content you produce and share: VALT requires specific
                permissions from you to provide you with our Services. For
                example, if you or any other user produces or disseminates
                content that is connected with VALT, you grant us permission to
                copy, keep, and share this content, all in accordance with our
                privacy policy.
              </li>
              <li>
                Remove or restrict access to content infringing policies or
                terms: In addition to using the content, you may create and
                share, you grant VALT permission to remove, restrict access to,
                or delete any content that violates any of our terms, policies,
                and applicable laws.
              </li>
              <li>
                Update downloaded software: VALT requires certain permissions to
                enable us to download and install regular software updates for
                the Services and software you use. Should you choose to use a
                Third-Party Service, you hereby understand and accept that VALT
                may at its discretion, install additional features, updates, and
                upgrades for that Third-Party Service.
              </li>
              <li>
                Use your details and information regarding your activities in
                relation to advertisements and sponsorships: VALT requires
                further permission to use details such as your account name,
                profile picture, as well as information regarding your actions
                concerning our Services, without compensation to you. These
                details and information will be used with advertisements,
                offers, and sponsorships that we showcase across our Services.
              </li>
            </ol>
          </div>
        </li>
        <li>
          <b>OUR PERMISSIONS</b>
          <div className="m-4 flex flex-col gap-4">
            <p>By accessing and/or using the Services, you are permitted to:</p>
            <ol
              className="ml-8 flex list-outside list-[lower-alpha] flex-col gap-4"
              role="list"
              type="a"
            >
              <li>
                Use our Services: VALT hereby grants you personally a
                non-transferable, non-exclusive, non-sublicensable, and limited
                right to access and use our Services. To ensure the enjoyment of
                your experience, the use of our Services must be in adherence to
                our terms, policies, and any applicable laws. If we determine
                that you did not comply with any of these terms, policies, and
                applicable laws, VALT may disable your access to our Services
                without a refund.
              </li>
              <li>
                Create and share content: VALT permits you to produce and share
                content you obtain in the course of using our services, subject
                to our terms, policies, and any applicable laws.
              </li>
              <li>
                Use Third-Party Services: VALT Services can be used by you to
                access other applications, services, content, and virtual items
                provided by other Third Parties. The use of Third-Party Services
                may require adherence to their own terms and conditions. Should
                there be an inconsistency between a Third-Party Services’ terms
                and conditions and VALT’s own terms and conditions, our Terms
                will prevail.
              </li>
              <li>
                Use of Services in supported countries: VALT’s Services are
                intended for use only in Supported Countries. You hereby
                acknowledge that some or all of VALT’s services may not be
                available, accessible, or prohibited from use in certain
                locations. You understand and accept that VALT’s Services will
                only be used in these Supported Countries and not anywhere else.
              </li>
            </ol>
          </div>
        </li>
        <li>
          <b>INTELLECTUAL PROPERTY RIGHTS</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              You acknowledge and agree that the VALT and its Services are the
              property of VALT or its licensors. Subject to your compliance with
              these Terms, VALT grants you a limited right to access and/or use
              the VALT. The right to access and/or use the VALT is a
              non-exclusive, non-transferable, revocable, limited license, and
              it is subject to the limitations and obligations contained herein.
              Nothing in these Terms gives you any license (other than as set
              out in this section), right, title, or ownership of, in, or to any
              of the VALT.
            </p>
            <p>
              You acknowledge and agree that VALT retains all rights, title, and
              interest in and to all copyrights, trademarks, trade secrets,
              patents, and any other proprietary rights in the VALT, the
              software and application programming interfaces (APIs) comprising
              the VALT, and all content therein. You acknowledge and agree that
              “VALT”, their trademarks, service marks, logos, and graphics are
              the registered trademarks or trademarks of VALT.
            </p>
            <p>
              You are not permitted to create, for commercial use, fan art
              (tokenized or physical), merchandise, or similar content stemming
              from the VALT and its affiliated links and projects.
            </p>
            <p>
              If you create any fan-art for personal, non-commercial use, the
              artwork must clearly state “VALT (RFOX Games) Fan Art” and a link
              to the VALT at{" "}
              <a
                href="https://www.rfoxvalt.com/"
                className="font-bold text-primary-100 underline"
              >
                https://www.rfoxvalt.com/
              </a>{" "}
              VALT reserves the right to determine if something is fan
              art/merchandise or not.
            </p>
          </div>
        </li>
        <li>
          <b>DATA PROTECTION</b>

          <div className="m-4 flex flex-col gap-4">
            In order to provide you with the VALT and its services, you
            acknowledge and agree that VALT may collect, store and process your
            personal data and/or information. By accessing and/or using the
            VALT, you acknowledge to have read, understood, and accepted the
            terms of VALT`s privacy policy, and you further acknowledge and
            agree that VALT may use such data and/or information in accordance
            with the terms of its privacy policy.
          </div>
        </li>
        <li>
          <b>USER REPRESENTATIONS</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              By accessing and/or using the Services, you represent and warrant
              that:
            </p>
            <ol
              role="list"
              type="a"
              className="ml-8 flex list-outside list-[lower-alpha] flex-col gap-4"
            >
              <li>
                you fully understand and have experience with tokens,
                cryptocurrencies, and digital assets, as well as
                blockchain-based infrastructures and services; and
              </li>
              <li>
                you fully understand the risks associated with the trading or
                holding of tokens, cryptocurrencies, and digital assets as well
                as the mechanics related to the use of such tokens,
                cryptocurrencies, and digital assets (including with respect to
                their storage and exchange).
              </li>
            </ol>
            <p>
              By accessing and/or using the VALT, you acknowledge that tokens,
              cryptocurrencies, and digital assets, are extremely volatile and
              shift quickly in terms of, among others, liquidity, market depth,
              and other characteristics. There is no guarantee against losses
              for accessing and/or using the VALT in correlation with digital
              assets.
            </p>
            <p>
              You further represent and warrant that you are not entering into
              transactions that are above your financial abilities and that you
              are aware of the risks related to tokens, cryptocurrencies, and
              digital assets, for which you are solely responsible and liable.
            </p>
            <p>
              You acknowledge and agree that VALT does not provide any advice,
              guidance, or recommendations on the opportunity to invest into,
              disinvest from, or remain invested in any Token. If you are
              considering purchasing Tokens as an investment, you should first
              contact your financial advisor for any such advice, guidance, or
              recommendation.
            </p>
            <p>
              By accessing and/or using the VALT, you warrant that you are a
              bona fide user of VALT services. By accessing VALT via a wallet or
              account creation via VALT, you confirm that you will not use VALT
              Services in connection with any of the following businesses,
              activities, practices or items, or any criminal activities
              whatsoever, including but not limited to:
            </p>
            <ol
              role="list"
              type="a"
              className="ml-8 flex list-outside list-[lower-alpha] flex-col gap-4"
            >
              <li>Terrorist financing;</li>
              <li>Money laundering;</li>
              <li>
                Illegal gambling Distributing or funding drugs and drug
                paraphernalia;
              </li>
              <li>Malicious hacking including payments for ransomware;</li>
              <li>
                Any business activity we believe poses an elevated financial
                risk, including legal liability, pyramid schemes, network
                marketing, and referral marketing programs;
              </li>
              <li>
                Knowingly or recklessly providing us with inaccurate or
                incomplete information through the Platform;
              </li>
              <li>
                Reverse engineering, disassembling, or otherwise attempting to
                construct, copy, or replicate the Platform’s source code,
                formulas, or processes;
              </li>
              <li>
                Interfering with the security of the Platform or the safe use of
                the Platform by others (including without limitation by way of
                distributing viruses, corrupted files, or other similar software
                or programs that may damage the operation of any computer
                hardware or software or which are otherwise directed at the
                website or its users);
              </li>
              <li>
                Using this Platform for any purpose that is unlawful or
                prohibited or in a way that infringes the intellectual property
                rights or other rights of any person (including us);
              </li>
              <li>
                Knowingly or recklessly using and/or taking advantage of a
                technical or technological error, loophole, or glitch on VALT’s
                Platform and Services;
              </li>
              <li>
                Using the Platform or the information contained in it for
                commercial purposes which are competitive to the Platform or our
                business or which would otherwise be detrimental or prejudicial
                to our interests in any way;
              </li>
              <li>
                Using systematic, repetitive, or other related methods which are
                designed to generate or obtain repetitive and repeated amounts
                of data or other information from or to the Platform or which
                may otherwise place an unreasonable load on the infrastructure
                of the Platform;
              </li>
              <li>
                Publishing, posting, distributing, disseminating, or sending
                ‘spam material’ or engaging in any communication that is
                offensive, false, unlawful, defamatory, indecent, unfair, or
                inappropriate in any way to others, which would reasonably be
                considered ‘spam’ or which is deliberately false, misleading, or
                deceptive (or likely to mislead or deceive);
              </li>
              <li>
                Collecting or storing personal data about other users of the
                Platform; or
              </li>
              <li>
                Doing anything else which may interfere with or negatively
                affect the operation of our Platform, Services, or other users.
              </li>
            </ol>
          </div>
        </li>
        <li>
          <b>USER REGISTRATION</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              You may be required to register an account or sign up with a
              wallet address with the VALT to be able to access its features and
              functions. You agree to keep your password (if any) confidential
              and will be responsible for all use of your account and password.
            </p>
            <p>
              To the maximum extent allowed by law, we accept no liability for
              any losses suffered by you with regard to losing access to your
              account or wallet.
            </p>
          </div>
        </li>
        <li>
          <b>PROHIBITED ACTIVITIES AND ACCEPTABLE USE</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              You may not access or use the VALT for any purpose other than that
              for which we make the VALT available. All uses must be acceptable
              and in accordance with existing terms, policies, and any
              applicable laws. The VALT may not be used in connection with any
              commercial endeavors except if agreed to in a binding legal
              contract with VALT.
            </p>
            <p>
              The prohibited activities with regards to the VALT include, but
              are not limited to:
            </p>
            <ol
              role="list"
              type="a"
              className="ml-8 flex list-outside list-[lower-alpha] flex-col gap-4"
            >
              <li>
                Systematically retrieve data or other content from the VALT to
                create or compile, directly or indirectly, a collection,
                compilation, database, or directory without written permission
                from us;
              </li>
              <li>
                Using the VALT in any unauthorized manner, including collecting
                usernames and/or email addresses of users by electronic or other
                means for the purpose of sending unsolicited email, or creating
                user accounts by automated means or under false pretenses;
              </li>
              <li>
                Using a buying agent or purchasing agent to make purchases on
                the VALT;
              </li>
              <li>
                Using the VALT to advertise or offer to sell goods and services;
              </li>
              <li>
                Circumventing or disabling or otherwise interfering with
                security-related features of the VALT, including features that
                prevent or restrict the use or copying of any VALT content or
                enforce limitations on the use of the VALT and/or the content
                contained therein;
              </li>
              <li>
                Engaging in unauthorized framing of or linking to the VALT;
              </li>
              <li>
                Defrauding or misleading us and/or other users, especially in
                any attempt to learn sensitive account information such as user
                password;
              </li>
              <li>
                Improperly using our support services or submitting false
                reports of abuse or misconduct;
              </li>
              <li>
                Engaging in any automated use of the system, such as using
                scripts to send comments or messages, or using any data mining,
                robots, or similar data gathering and extraction tools;
              </li>
              <li>
                Interfering with, disrupting, or creating an undue burden on the
                VALT or the networks or services connected to the VALT;
              </li>
              <li>
                Attempting to impersonate another user or person or use the
                username of another user;
              </li>
              <li>Selling or otherwise transferring your profile;</li>
              <li>
                Using any information obtained from the VALT in order to harass,
                abuse, or harm another person;
              </li>
              <li>
                Undertaking any conduct that causes, or is likely to cause harm,
                loss, or any other kind of damage to another person;
              </li>
              <li>
                Use of the VALT as part of any effort to compete with us or
                otherwise use VALT and/or the content contained within for any
                revenue-generating endeavor or commercial enterprise;
              </li>
              <li>
                Deciphering, decompiling, disassembling, or reverse engineering
                any of the software comprising or in any way making up a part of
                the VALT;
              </li>
              <li>
                Attempting to bypass any measures of the VALT designed to
                prevent or restrict access to the VALT, or any portion of it;
              </li>
              <li>
                Harassing, intimidating, or threatening any of our employees or
                agents engaged in providing any portion of the VALT to you;
              </li>
              <li>
                Deleting copyright or other proprietary rights notice from any
                content from or derived from the VALT;
              </li>
              <li>
                Copying or adapting the VALT’s software, including, but not
                limited to HTML, JavaScript, or other code;
              </li>
              <li>
                Uploading or transmitting (or attempting to upload or to
                transmit) viruses, Trojan horses, or other material, including
                excessive use of capital letters and spamming (continuous
                posting of repetitive text), that interferes with any party’s
                uninterrupted use and enjoyment of the VALT or that modifies,
                impairs, disrupts, alters, or interferes with the use, features,
                functions, operation, or maintenance of the VALT;
              </li>
              <li>
                Uploading or transmitting (or attempting to upload or transmit)
                any material that acts as a passive or active information
                collection or transmission mechanism, including, without
                limitation, clear graphics interchange formats (“GIFs”), 1×1
                pixels, web bugs, cookies, or other similar devices (sometimes
                referred to as “spyware” or “passive collection mechanisms” or
                “PCMs”);
              </li>
              <li>
                Except as may be the result of standard search engines or
                Internet browser usage, using, launching, developing, or
                distributing any automated system, including, without
                limitation, any spider, robot, cheat utility, scraper, or
                offline reader that accesses the VALT, or using or launching any
                unauthorized script or other software;
              </li>
              <li>
                Disparaging, tarnishing, or otherwise harming, us and/or the
                VALT, such harm which is assessed and judged at our sole
                discretion and opinion; and
              </li>
              <li>
                Using the VALT in a manner inconsistent with any applicable laws
                or regulations.
              </li>
            </ol>
          </div>
        </li>
        <li>
          <b>PAYMENT AND FEES</b>

          <div className="m-4 flex flex-col gap-4">
            <b>Third Parties</b>
            <p>
              Third-Party services are not controlled by VALT. You agree to use
              Third-party service at your own risk. You agree to indemnify VALT
              from all liability in relation to third-party services. We accept
              no liability owed to you or to any third party for any claims or
              damages that may arise as a result of any transactions that you
              engage in via a third-party or any other transactions that you
              conduct via a third party.
            </p>
          </div>
        </li>
        <li>
          <b>TAXES</b>

          <div className="m-4 flex flex-col gap-4">
            You shall be solely responsible for any taxes applying to the
            payments you make or receive through the VALT, and to collect,
            report, and remit such taxes to the appropriate tax authorities. You
            acknowledge and agree that, at the moment, VALT is not able to draft
            a taxation report concerning the operation executed and that it is
            your duty to collect all the information required by the competent
            tax authorities in order to comply with your tax obligations.
          </div>
        </li>
        <li>
          <b> NFTs</b>

          <div className="m-4 flex flex-col gap-4">
            NFTs may be interoperable with the VALT. Under no circumstance shall
            the VALT be liable for loss of NFTs.
          </div>
        </li>
        <li>
          <b>PURCHASES AND REFUNDS</b>

          <div className="m-4 flex flex-col gap-4">
            To the maximum extent permitted by law, you agree and acknowledge
            that we are under no obligation to allow refunds on the VALT in
            relation to any transactions that may be refundable. Any refunds or
            compensation, whether monetary or otherwise, in relation to the VALT
            and your use of the VALT and all its features and assets are
            considered, accepted, or rejected at our sole discretion. This
            includes, but is not limited to, the following scenarios in which
            you may potentially suffer loss, harm, or damage:
            <ol
              role="list"
              type="a"
              className="ml-8 flex list-outside list-[lower-alpha] flex-col gap-4"
            >
              <li>accidental purchases made by you;</li>
              <li>
                glitches, malfunctions, or other technical errors encountered on
                the VALT;
              </li>
              <li>
                being made the victim of another user’s fraud, deceit,
                prohibited activity, or misdemeanor;
              </li>
              <li>fluctuating pricing by other users;</li>
              <li>unreasonable pricing by other users;</li>
              <li>
                the use of the VALT and/or its features and assets in a manner
                not consistent with a relevant intended purpose.
              </li>
            </ol>
          </div>
        </li>
        <li>
          <b>SUBMISSIONS</b>

          <div className="m-4 flex flex-col gap-4">
            You acknowledge and agree that any questions, comments, suggestions,
            ideas, feedback, or other information regarding the VALT, the App,
            and the Smart Contracts (“Submissions”) provided by you to us are
            non-confidential and should become our sole property. We should own
            exclusive rights, including all intellectual property rights, and
            should be entitled to the unrestricted use and dissemination of
            these Submissions to any lawful purpose, commercial, or otherwise,
            without acknowledgment from or compensation for you. You hereby
            waive any moral rights to any such Submissions, and you hereby
            warrant that any such Submissions are original with you or that you
            have the right to submit such Submissions. You agree there should be
            no recourse against us for any alleged or actual infringement or
            misappropriation of any proprietary right in your Submissions.
          </div>
        </li>
        <li>
          <b>THIRD-PARTY WEBSITE AND CONTENT</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              The VALT may contain (or you may be sent via the VALT) links to
              other websites (“Third-Party Websites”), as well as articles,
              photographs, text, graphics, pictures, designs, music, sound,
              video, information, applications, software, and other content or
              items belonging to or originating from third parties (“Third-Party
              Content”). Such Third-Party Websites and Third-Party Content are
              not investigated, monitored, or checked for accuracy,
              appropriateness, or completeness by us, and we are not responsible
              for any Third-Party Websites accessed through the VALT, or any
              Third-Party Content posted on, available through, or installed
              from the VALT, including the content, accuracy, offensiveness,
              opinions, reliability, privacy practices, or other policies of or
              contained in the Third-Party Websites or the Third-Party Content.
              Inclusion of, linking to, or permitting the use or installation of
              any Third-Party Websites or any Third-Party Content does not imply
              approval or endorsement thereof by us. If you decide to leave the
              VALT and access the Third-Party Websites or to use or install any
              Third-Party Content, you do so at your own risk and you should be
              aware that these Terms and Conditions no longer govern your use of
              and interaction with these VALTs and/or Content. You should review
              the applicable terms and policies, including privacy and data
              gathering practices, of any website to which you navigate from the
              VALT or relating to any applications you use or install from the
              VALT.
            </p>
            <p>
              Any purchase you make through Third-Party Websites will be through
              other websites and from other companies, and we take no
              responsibility whatsoever in relation to such purchases which are
              exclusively between you and the applicable third party. You agree
              and acknowledge that we do not endorse the products and services
              offered on Third-Party Websites and we are not liable for any harm
              caused by your purchase of such products and services.
              Additionally, you agree and acknowledge that we accept no
              liability for any losses sustained by you or harm caused to you
              relating to or resulting, in any way, from any Third-Party Content
              or any contact with Third-Party Websites.
            </p>
          </div>
        </li>
        <li>
          <b>ADVERTISING</b>

          <div className="m-4 flex flex-col gap-4">
            We may allow advertisers to display their advertisements and other
            information in certain areas of the VALT, including sidebars,
            pop-ups, and banners. If you are an advertiser, you should take full
            responsibility for any advertisements you place on the VALT, and any
            services provided on the VALT, or products sold through those
            advertisements. Further, as an advertiser, you warrant and represent
            that you possess all rights and authority to place advertisements on
            the VALT, including, but not limited to, intellectual property
            rights, publicity rights, and contractual rights. We simply provide
            the space to place such advertisements, and we have no other
            relationship with advertisers.
          </div>
        </li>
        <li>
          <b>TERMINATION OF USE AND BANNING OF WALLET ADDRESS</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              You terminate these Terms at any time by withdrawing consent to
              abide by these terms via writing. If you withdraw consent, or
              otherwise terminate these Terms, you will not receive any refunds
              for any purchases that you might make on or through the VALT.
            </p>
            <p>
              You agree that we, in our sole discretion and for any or no
              reason, may terminate these Terms or suspend and/or terminate your
              use of our platform, or ban your wallet address from using the
              VALT without the provision of prior notice. You agree that any
              suspension or termination of your access to the VALT may be
              without prior notice and that we will not be liable to you or to
              any third party for any such suspension or termination.
            </p>
            <p>
              If we terminate these Terms or suspend or terminate your access or
              a wallet’s access to or use of the VALT due to your breach of
              these Terms or any suspected fraudulent, abusive, or illegal
              activity (including, without limitation, if you engage in any of
              the Prohibited Activities), then termination of these Terms will
              be in addition to any other remedies we may have at law or in
              equity.
            </p>
            <p>
              We have the right, without provision of prior notice, to take
              appropriate legal action, including, without limitation referral
              to law enforcement or regulatory authority, or notifying the
              harmed party of any illegal or unauthorized use of the VALT.
              Without limiting the foregoing, we have the right to fully
              cooperate with any law enforcement authorities or court order
              requestion or direct us to disclose the identity or other
              information of anyone using the VALT.
            </p>
            <p>
              Upon any termination or expiration of these Terms, whether by you
              or us, you may no longer have access to information that you have
              used or gathered on the VALT or that is related to your wallet,
              and you acknowledge that we will have no obligation to maintain
              any such information in our databases or to forward any such
              information to you or to any third party.
            </p>
          </div>
        </li>
        <li>
          <b>LIMITATION OF LIABILITY</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              In no event will VALT, its officers, shareholders, employees,
              agents, directors, subsidiaries, affiliates, successors, assigns,
              suppliers, or licensors be liable for any loss or damages,
              including without limitation, direct, indirect, special,
              consequential, or punitive loss or damages, arising from or
              related to Your use of the VALT, whether in an action of contract,
              tort or otherwise, and regardless of whether such damages were
              foreseeable and whether or not VALT was advised of the possibility
              of such damages.
            </p>
            <p>
              Without limiting the generality of the foregoing, VALT takes no
              responsibility for and will not be liable for any financial or
              other loss or damages arising from or related to the use of the
              VALT, including, without limitation, to any of the following: (i)
              delays, interruption or loss of services; (ii) technical failure,
              malfunction or shutdown; (iii) server failure, hacks or
              unavailability; (iv) data loss; (v) corrupted data on VALT’
              servers; (vi) failure to update or provide correct information;
              (vii) “phishing” or other websites masquerading as VALT; (viii)
              stolen, lost, or unauthorized use of your means of authorization;
              (ix) loss of business or goodwill.
            </p>
            <p>
              The limitation of liability set out above shall not be applicable
              in case of loss or damages caused by VALT or any of its employees
              by intentional misconduct or gross negligence.
            </p>
            <p>
              The VALT supports or is integrated with third-party services. VALT
              takes no responsibility for any third-party services and will not
              be liable for any loss or damages caused by such third-party
              services.
            </p>
            <p>
              The VALT is provided on an “as is” and “as available” basis
              without any representation or warranty of any kind, whether
              express or implied, to the maximum extent permitted by applicable
              laws. VALT disclaims any implied warranties of title,
              merchantability, fitness for a particular purpose, and/or
              non-infringement.
            </p>
          </div>
        </li>
        <li>
          <b>INDEMNIFICATION</b>

          <div className="m-4 flex flex-col gap-4">
            To the fullest extent permitted under applicable laws, you agree to
            hold harmless and indemnify VALT, its officers, shareholders,
            employees, agents, directors, subsidiaries, affiliates, successors,
            assigns, suppliers, or licensors from and against all third-party
            claims and all liabilities, damages, assessments, losses, costs, or
            expenses (including reasonable attorney fees) resulting from or
            arising out of:
            <ol
              role="list"
              type="a"
              className="ml-8 flex list-outside list-[lower-alpha] flex-col"
            >
              <li>
                Your alleged or actual breach of these Terms, including, without
                limitation, Your express representations, and warranties;
              </li>
              <li>Your alleged or actual use or misuse of the Services; and</li>
              <li>
                Your alleged or actual infringement or violation of any laws or
                of the rights of a third party.
              </li>
            </ol>
          </div>
        </li>
        <li>
          <b>ENTIRE AGREEMENT</b>

          <div className="m-4 flex flex-col gap-4">
            These Terms constitute all the terms and conditions agreed upon
            between you and VALT and supersede any prior agreements in relation
            to the subject matter of these Terms, whether written or oral.
          </div>
        </li>
        <li>
          <b>SEVERABILITY AND WAIVER</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              Unless as otherwise stated in these Terms, should any provision of
              these Terms be held totally or partially invalid or unenforceable,
              such invalidity or unenforceability shall not in any manner affect
              or render invalid or unenforceable the remaining provisions of
              these Terms, and the application of that provision shall be
              enforced to the extent permitted by applicable laws.
            </p>
            <p>
              The failure of VALT to exercise or enforce any of the rights or
              provisions of these Terms shall not be considered a waiver of
              VALT’s rights to do so.
            </p>
          </div>
        </li>
        <li>
          <b>ASSIGNMENT</b>

          <div className="m-4 flex flex-col gap-4">
            VALT may assign these Terms and/or delegate any of its obligations
            hereunder, in whole or in part. You may not assign these Terms or
            any part of them, nor transfer or sub-license Your rights under
            these Terms to any third party, unless in connection with the
            transfer of the Tokens.
          </div>
        </li>
        <li>
          <b>NO PARTNERSHIP</b>
          <div className="m-4 flex flex-col gap-4">
            Nothing contained in these Terms shall be deemed or construed to
            create a principal and agent, partnership, or joint venture
            relationship between you and VALT.
          </div>
        </li>
        <li>
          <b>FORCE MAJEURE</b>
          <div className="m-4 flex flex-col gap-4">
            VALT will not be deemed in default of these Terms to the extent that
            performance of its obligations is delayed or prevented by reason of
            any external force including, without limitation, war,
            insurrections, bank failures, strikes, fires, floods, earthquakes,
            labour disputes, epidemics, governmental regulations, freight
            embargoes, natural disaster, act of government or any other cause
            beyond VALT’ reasonable control.
          </div>
        </li>
        <li>
          <b>GOVERNING LAW</b>

          <div className="m-4 flex flex-col gap-4">
            These Terms and Conditions, and your use of the VALT, are/is
            governed by and constructed in accordance with the laws of the
            British Virgin Islands, applicable to agreements made and to be
            entirely performed in the British Virgin Islands, without regard to
            its conflicts of law principles.
          </div>
        </li>
        <li>
          <b>DISPUTE RESOLUTION</b>

          <div className="m-4 flex flex-col gap-4">
            Should there be a dispute with us that is connected to your use of
            our VALT services, you may contact us, and our team will endeavor to
            resolve any existing issues. However, in the event a dispute needs
            to be resolved by a court, the courts of the British Virgin Islands
            shall judge and resolve the matter.
          </div>
        </li>
        <li>
          <b>ACCESSING AND AMENDING PERSONAL INFORMATION</b>

          <div className="m-4 flex flex-col gap-4">
            <p>
              You are entitled to review, correct, or amend your personal
              information, or to delete that information where it is inaccurate.
              You may do this by contacting us at{" "}
              <a
                href="mailto:support@rfox.com"
                className="font-bold text-primary-100 underline"
              >
                support@rfox.com
              </a>
              .
            </p>
            <p>
              If your access to the VALT is suspended or terminated, we will
              keep your information in our database for at least seven years for
              regulatory purposes. This ensures that those who are attempting to
              avoid fraud cannot achieve this by simply closing or terminating
              their access. When your access is closed or terminated, your
              information will not be used by us for any further purposes,
              including sharing with third parties.
            </p>
          </div>
        </li>
      </ol>
    </div>
  );
};

const AcceptTerms = () => {
  const { control, handleSubmit } = useForm<{
    userConsent: boolean;
  }>();
  const { data } = useUserConsent();
  const { mutate } = useConsentUser();

  const onSubmit = (values: { userConsent: boolean }) => {
    mutate(values);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="max-h-[calc(100vh-160px)] overflow-auto">
        <TermsAndCondition />
      </div>
      <div className="border-t-2 border-primary-100">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="overflow-hidden shadow sm:rounded-md">
            <div className="space-y-6 bg-dark-300 px-4 py-5 sm:p-6">
              <fieldset>
                <div className="mt-4 space-y-4">
                  <div className="flex items-center">
                    <div className="flex h-5 items-center">
                      <Controller
                        name="userConsent"
                        control={control}
                        render={({ field: { onChange, value, ref } }) => (
                          <input
                            type="checkbox"
                            id="tnc"
                            onChange={(e) => {
                              onChange(e.target.checked);
                              return onSubmit({
                                userConsent: e.target.checked,
                              });
                            }}
                            className="h-6 w-6 rounded border-gray-300 text-primary-100 focus:ring-primary-100"
                            checked={value ?? data?.userConsent ?? false}
                            ref={ref}
                          />
                        )}
                      />
                    </div>
                    <div className="ml-3">
                      <label
                        htmlFor="userConsent"
                        className="text-lg font-medium text-light-150"
                      >
                        I agree to Terms and Conditions
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AcceptTerms;
